<template>
  <z-dialog
    :show="isVisible"
    :modalSize="modalSize"
    :dStyle="dStyle"
    :bdStyle="bdStyle"
  >
    <template v-slot:header>
      <div class="row custom-header">
        <div class="col-md-6">
          <h4 class="modal-title">
            {{ title }}
          </h4>
        </div>
        <div class="col-md-5">
          <z-message
            v-model="message"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
        <div class="col-md-1 custom-close">
          <button
            type="button"
            class="btn-close"
            @click="close(false)"
          ></button>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-12">
          <p>
            Use the following to manage client lists for messaging and
            establishing cardio parameters.
          </p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <div class="input-group">
            <span class="input-group-text">choose list</span>
            <select v-model="list" class="form-select" @change="choseList">
              <option v-for="list of lists" :value="list" :key="list.id">
                {{ list.name }}
              </option>
            </select>
            <button
              class="btn btn-outline-danger"
              v-show="showList"
              @click="confirmRemoval"
              title="remove list"
            >
              <i class="fas fa-minus"></i>
            </button>
            <span class="input-group-text">or create</span>
            <input
              type="text"
              class="form-control custom-list-name"
              v-model="newListName"
              placeholder="new list"
              @keyup="clearList"
            />
            <button
              class="btn btn-outline-primary"
              @click="addList"
              title="add list"
            >
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row custom-list-wrapper">
        <div class="col">
          <div class="list-group custom-list" v-if="showList">
            <div v-if="listClients.length === 0">add a client</div>
            <div
              v-for="item of listClients"
              :key="item.id"
              class="list-group-item list-group-item-action"
            >
              <input
                type="checkbox"
                :checked="item.isSelected === 1"
                class="z-checkbox-small"
                @click="selectClient('list', item.id)"
              />
              <span class="ms-2">{{ setClientName(item) }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-auto custom-arrow-buttons-wrapper">
          <div class="custom-arrow-buttons">
            <button
              class="btn btn-sm btn-outline-secondary"
              v-show="showLeftArrowButton"
              title="add client"
              @click="addClient"
            >
              <i class="fas fa-angle-left"></i>
            </button>
            <button
              class="btn btn-sm btn-outline-secondary mt-1"
              v-show="showRightArrowButton"
              title="remove client"
              @click="removeClient"
            >
              <i class="fas fa-angle-right"></i>
            </button>
          </div>
        </div>
        <div class="col">
          <div v-show="listName != ''" class="list-group custom-list">
            <div
              v-for="item of clients"
              :key="item.user_id"
              class="list-group-item list-group-item-action"
            >
              <input
                type="checkbox"
                :checked="item.isSelected === 1"
                class="z-checkbox-small"
                @click="selectClient('client', item.user_id)"
              />
              <span class="ms-2">{{ setClientName(item) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col custom-list-count">
          <span v-if="listClients.length > 0">{{ numListClients }}</span>
        </div>
        <div class="col custom-client-count">
          <span v-if="list !== null">{{ numClients }}</span>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': highlightSave }"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              class="btn btn-primary me-2"
              :class="{ 'btn-danger': highlightSave }"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="close(false)"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm-delete
    :show="actionDelete"
    :confirmTitle="confirmTitle"
    :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZStepper from '@/Components/ZElements/Stepper'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'list-dialog',
  components: {
    ZDialog,
    ZStepper,
    ZTable,
    ZSelect,
    ConfirmDelete,
    ZMessage,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
    dStyle: String,
    bdStyle: String,
  },
  data() {
    return {
      modalSize: 'modal-lg',
      list: null,
      listName: '',
      newListName: '',
      confirmTitle: 'Remove List',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this List',
      actionDelete: null,
      highlightSave: false,
      message: '',
    }
  },
  mounted() {
    this.reset()
  },
  emits: ['close', 'saved', 'setCardioGoals', 'sendMessage'],
  computed: {
    ...mapGetters('usercardio', ['lists', 'clients']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        _title = this.show.title
      }
      return _title
    },
    listClients() {
      let _clients = []
      let found = this.lists.find((x) => x.name === this.listName)
      if (found) {
        _clients = found.clients
      }
      return _clients
    },
    showList() {
      return this.listName !== ''
    },
    showLeftArrowButton() {
      let _show = false
      _show = this.clients.some((x) => {
        return x.isSelected === 1
      })
      return _show && this.showList
    },
    showRightArrowButton() {
      let _show = false
      _show = this.listClients.some((x) => {
        return x.isSelected === 1
      })
      return _show && this.showList
    },
    numClients() {
      let _data = ''
      if (this.clients.length > 0) {
        _data = `count: ${this.clients.length}`
      }
      return _data
    },
    numListClients() {
      let _data = ''
      if (this.listClients.length > 0) {
        _data = `count: ${this.listClients.length}`
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'setList',
      'saveList',
      'resetLists',
      'removeList',
    ]),
    setClientName(item) {
      let name = ''
      if (item.nickname !== '') {
        name = `${item.lastname}, ${item.firstname} (${item.nickname})`
      } else {
        name = `${item.lastname}, ${item.firstname}`
      }
      return name
    },
    reset() {
      // reset things
      this.highlightSave = false
      this.list = null
      this.listName = ''
      this.newListName = ''
      this.message = ''
      this.resetLists()
    },
    addList() {
      // add a new user-defined Client List
      this.highlightSave = true
      this.list = null
      this.listName = this.newListName
      let data = {
        name: 'add',
        value: {
          id: null,
          name: this.newListName,
          isSelected: false,
          clients: [],
        },
      }
      this.setList(data)
      this.list = this.lists.find((x) => x.name === this.newListName)
    },
    addClient() {
      // add a new client member to the
      // user-defined Client List
      this.highlightSave = true
      let data = {
        name: 'addClient',
        value: null,
        listName: this.listName,
      }
      this.setList(data)
    },
    removeClient() {
      // remove the client member
      this.highlightSave = true
      let data = {
        name: 'removeClient',
        value: null,
        listName: this.listName,
      }
      this.setList(data)
    },
    choseList() {
      // choosing a List (from the drop-down)
      console.log('Chosen a List', this.list)
      this.newListName = ''
      this.listName = this.list.name
    },
    selectClient(list, id) {
      // select (check) a client member
      let data = {
        name: `select-${list}`,
        value: id,
        listName: this.list ? this.list.name : null,
      }
      this.setList(data)
    },
    clearList() {
      this.list = null
      this.listName = ''
    },
    confirmRemoval() {
      // pop-up confirmation
      this.actionDelete = true
    },
    async performDeletion() {
      // perform the removal of the Client List
      this.actionDelete = null
      // Make Call to Server to Remove List
      console.log('Removing List', {
        lists: this.lists,
        list: this.list,
      })
      if (this.list.id !== null) {
        let result = await this.removeList(this.list.id)
        if (result.errors.length === 0) {
          let data = {
            name: 'remove',
            value: this.list.id,
          }
          this.setList(data)
          this.reset()
        } else {
          alert('Error: ' + result.data)
        }
      } else {
        let data = {
          name: 'remove',
          value: this.list.id,
        }
        this.setList(data)
        this.reset()
      }
    },
    closeModal() {
      this.actionDelete = null
    },
    close(isSaved) {
      this.reset()
      if (isSaved) {
        this.$emit('saved')
      } else {
        this.$emit('close')
      }
    },
    async performSave(closeIt) {
      // perform the Save of the Client List
      // and its members
      this.highlightSave = false
      // Make Call to Server to Save List
      let ids = []
      this.list.clients.forEach((element) => {
        ids.push(element.id)
      })
      if (ids.length > 0) {
        let data = {
          orgId: this.show.orgid,
          listId: this.list.id,
          listName: this.list.name,
          userIds: ids,
        }
        let result = await this.saveList(data)
        if (result.errors.length > 0) {
        }
        if (closeIt) {
          this.close(true)
        }
      } else {
        this.message = 'Add client(s) to your list.'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  position: absolute;
  right: -10px;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.form-select:focus {
  outline: none !important;
  box-shadow: none !important;
}
.custom-list {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-arrow-buttons-wrapper {
  padding: 0;
}
.custom-arrow-buttons {
  width: 30px;
  text-align: center;
  button {
    font-size: 1.2em;
  }
}
.custom-list-name {
  min-width: 100px;
}
.custom-list-wrapper {
  min-height: 350px;
}
.custom-client-count {
  text-align: right;
  font-size: 0.8em;
}
.custom-list-count {
  font-size: 0.8em;
}
</style>
